// site scss bundle - will be extracted into a css file by ExtractTextPlugin
import '../c/main.scss'

// polyfill for native Promise objects - required by whatwg-fetch
// https://babeljs.io/docs/usage/polyfill/
import 'babel-polyfill'

// polyfill for fetch api - https://github.com/github/fetch
import 'whatwg-fetch'

// polyfill for RequestAnimationFrame
import 'raf/polyfill'

// scrollsnap (looks like no default file in package.json.?)
// import 'scrollsnap-polyfill/dist/scrollsnap-polyfill.bundled';

// polyfill native browser smooth scrolling
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

// hackyfill for firefox and maybe other browsers so we can use
// document.QuerySelectorAll('...').forEach(...)
// TODO don't leave this here, need a wrapper for forEach
if (window.NodeList.prototype.forEach === undefined) {
  window.NodeList.prototype.forEach = window.Array.prototype.forEach
}

import './src/site'
import './src/stories/index'
import './src/stories/detail'
import './src/collection/collection'
import './src/collection/product'
import './src/collection/filters'
import './src/contact'
import './src/search'
import './src/home'
import './src/checkout'
import './src/services/service'



// WEBPACK FOOTER //
// ./assets/j/main.js